import { ImageSource } from '@/types/image'
import { Platform } from '@/types/platform'

export function imageSources({
  platform,
}: {
  platform: Platform
}): ImageSource[] {
  const items: ImageSource[] = [
    {
      text: 'Legion-Media',
      value: 'Legion-Media',
    },
    {
      text: 'Personastars',
      value: 'Personastars',
    },
    {
      text: 'Getty Images',
      value: 'Getty Images',
      needConfirmation: true,
    },
    {
      text: 'Соцсети',
      value: 'Соцсети',
    },
    {
      text: 'Кадр из видео',
      value: 'Кадр из видео',
    },
    {
      text: 'Архив пресс-службы',
      value: 'Архив пресс-службы',
    },

    {
      text: 'Фото пресс-службы',
      value: 'Фото пресс-службы',
    },
    {
      text: 'Shutterstock',
      value: 'Shutterstock',
    },
    {
      text: '/ТАСС',
      value: '/ТАСС',
    },
    {
      text: '/РИА Новости',
      value: '/РИА Новости',
    },
    {
      text: 'East News',
      value: 'East News',
    },
    {
      text: 'Архив',
      value: 'Архив',
    },
    {
      text: 'Фото с сайта продавца',
      value: 'Фото с сайта продавца',
    },
    {
      text: 'Gallo images',
      value: 'Gallo images',
    },
    {
      text: 'Агентство «Москва»',
      value: 'Агентство «Москва»',
    },
    {
      text: 'Коммерсант',
      value: 'Коммерсант',
    },
    {
      text: 'Фотодом',
      value: 'Фотодом',
    },
    {
      text: 'IMAX TREE SRL',
      value: 'IMAX TREE SRL',
    },
    {
      text: 'Reuters',
      value: 'Reuters',
    },
    {
      text: 'Unsplash',
      value: 'Unsplash',
      needConfirmation: true,
    },
    {
      text: 'Magnific',
      value: 'Magnific',
      needConfirmation: true,
    },
    {
      text: 'Pixabay',
      value: 'Pixabay',
      needConfirmation: true,
    },
    {
      text: 'Pexels',
      value: 'Pexels',
      needConfirmation: true,
    },
    {
      text: 'Burst',
      value: 'Burst',
      needConfirmation: true,
    },
    {
      text: 'ISO Republic',
      value: 'ISO Republic',
      needConfirmation: true,
    },
    {
      text: 'Life of Pix',
      value: 'Life of Pix',
      needConfirmation: true,
    },
    {
      text: 'Gratisography',
      value: 'Gratisography',
      needConfirmation: true,
    },

    {
      text: 'Splash',
      value: 'Splash',
    },
    {
      text: 'ВИЛТА',
      value: 'ВИЛТА',
    },
    {
      text: 'Кинопоиск',
      value: 'Кинопоиск',
    },
    {
      text: 'МИА «Россия Сегодня»',
      value: 'МИА «Россия Сегодня»',
    },
    {
      text: 'Created by techinsider.ru using the Midjourney web app',
      value: 'Created by techinsider.ru using the Midjourney web app',
      access: [Platform.popmech],
    },
  ]

  return items.reduce<ImageSource[]>((acc, item) => {
    if (!item.access?.length || item.access.includes(platform)) {
      acc.push(Object.freeze(item))
    }

    return acc
  }, [])
}
